import { useMutation } from "@tanstack/react-query";
import { ApiResult } from "../../../../types/ApiResult";
import { apiClient } from "../../../../lib/api-client";

export const useAddUserAccessLog = (
    onSuccess: (result: ApiResult) => void,
    onError: (error: string) => void) => {

    const { mutate, isLoading } = useMutation({
        mutationFn: async (params: { documentID?: string, resourceGuideID?: number }) => {
            return await apiClient.post("document/add-user-access-log", params) as ApiResult;
        },
        onSuccess: async (result) => {
            if (result.isSuccess)
                onSuccess(result);
            else
                onError('Error when adding user access log: ' + result.errorMessage!);
        },
        onError(error) {
            onError(error as string);
        }
    });

    return {
        mutate, isLoading
    }
}